import type { ApiRequest } from '@zurich-framework/core/api';

type DeleteGenericDocumentsParams = { documentId: string };

export const deleteVSGAPhoto: ApiRequest<{}, DeleteGenericDocumentsParams> = {
  source: 'app',
  route: '/document',
  method: 'DELETE',
};
